!(function (n, t) {
  typeof exports === 'object' && typeof module !== 'undefined'
    ? (module.exports = t())
    : typeof define === 'function' && define.amd
      ? define(t)
      : ((n =
        typeof globalThis !== 'undefined'
          ? globalThis
          : n || self).KeenSlider = t())
})(this, () => {
  'use strict'
  var n = function () {
    return (
      (n =
        Object.assign ||
        function (n) {
          for (var t, i = 1, e = arguments.length; i < e; i++) {
            for (const r in (t = arguments[i])) { Object.prototype.hasOwnProperty.call(t, r) && (n[r] = t[r]) }
          }
          return n
        }),
      n.apply(this, arguments)
    )
  }
  function t (n, t, i) {
    if (i || arguments.length === 2) {
      for (var e, r = 0, a = t.length; r < a; r++) {
        (!e && r in t) ||
          (e || (e = Array.prototype.slice.call(t, 0, r)), (e[r] = t[r]))
      }
    }
    return n.concat(e || Array.prototype.slice.call(t))
  }
  function i (n) {
    return Array.prototype.slice.call(n)
  }
  function e (n, t) {
    const i = Math.floor(n)
    return i === t || i + 1 === t ? n : t
  }
  function r () {
    return Date.now()
  }
  function a (n, t, i) {
    if (((t = `data-keen-slider-${t}`), i === null)) return n.removeAttribute(t)
    n.setAttribute(t, i || '')
  }
  function o (n, t) {
    return (
      (t = t || document),
      typeof n === 'function' && (n = n(t)),
      Array.isArray(n)
        ? n
        : typeof n === 'string'
          ? i(t.querySelectorAll(n))
          : n instanceof HTMLElement
            ? [n]
            : n instanceof NodeList
              ? i(n)
              : []
    )
  }
  function u (n) {
    n.raw && (n = n.raw),
    n.cancelable && !n.defaultPrevented && n.preventDefault()
  }
  function s (n) {
    n.raw && (n = n.raw), n.stopPropagation && n.stopPropagation()
  }
  function c () {
    let n = []
    return {
      add (t, i, e, r) {
        t.addListener ? t.addListener(e) : t.addEventListener(i, e, r),
        n.push([t, i, e, r])
      },
      input (n, t, i, e) {
        this.add(
          n,
          t,
          (function (n) {
            return function (t) {
              t.nativeEvent && (t = t.nativeEvent)
              let i = t.changedTouches || [],
                e = t.targetTouches || [],
                r = t.detail && t.detail.x ? t.detail : null
              return n({
                id: r
                  ? r.identifier
                    ? r.identifier
                    : 'i'
                  : e[0]
                    ? e[0]
                      ? e[0].identifier
                      : 'e'
                    : 'd',
                idChanged: r
                  ? r.identifier
                    ? r.identifier
                    : 'i'
                  : i[0]
                    ? i[0]
                      ? i[0].identifier
                      : 'e'
                    : 'd',
                raw: t,
                x: r && r.x ? r.x : e[0] ? e[0].screenX : r ? r.x : t.pageX,
                y: r && r.y ? r.y : e[0] ? e[0].screenY : r ? r.y : t.pageY
              })
            }
          })(i),
          e
        )
      },
      purge () {
        n.forEach((n) => {
          n[0].removeListener
            ? n[0].removeListener(n[2])
            : n[0].removeEventListener(n[1], n[2], n[3])
        }),
        (n = [])
      }
    }
  }
  function d (n, t, i) {
    return Math.min(Math.max(n, t), i)
  }
  function l (n) {
    return (n > 0 ? 1 : 0) - (n < 0 ? 1 : 0) || +n
  }
  function f (n) {
    const t = n.getBoundingClientRect()
    return {
      height: e(t.height, n.offsetHeight),
      width: e(t.width, n.offsetWidth)
    }
  }
  function p (n, t, i, e) {
    const r = n && n[t]
    return r == null ? i : e && typeof r === 'function' ? r() : r
  }
  function v (n) {
    return Math.round(1e6 * n) / 1e6
  }
  function h (n) {
    let t, i, e, r, a, o
    function u (t) {
      o || (o = t), s(!0)
      let a = t - o
      a > e && (a = e)
      const l = r[i]
      if (l[3] < a) return i++, u(t)
      let f = l[2],
        p = l[4],
        v = l[0],
        h = l[1] * (0, l[5])(p === 0 ? 1 : (a - f) / p)
      if ((h && n.track.to(v + h), a < e)) return d()
      ;(o = null), s(!1), c(null), n.emit('animationEnded')
    }
    function s (n) {
      t.active = n
    }
    function c (n) {
      t.targetIdx = n
    }
    function d () {
      let n
      ;(n = u), (a = window.requestAnimationFrame(n))
    }
    function l () {
      let t
      ;(t = a),
      window.cancelAnimationFrame(t),
      s(!1),
      c(null),
      o && n.emit('animationStopped'),
      (o = null)
    }
    return (t = {
      active: !1,
      start (t) {
        if ((l(), n.track.details)) {
          let a = 0,
            o = n.track.details.position
          ;(i = 0),
          (e = 0),
          (r = t.map((n) => {
            let t,
              i = Number(o),
              r = (t = n.earlyExit) !== null && void 0 !== t ? t : n.duration,
              u = n.easing,
              s = n.distance * u(r / n.duration) || 0
            o += s
            const c = e
            return (e += r), (a += s), [i, n.distance, c, e, n.duration, u]
          })),
          c(n.track.distToIdx(a)),
          d(),
          n.emit('animationStarted')
        }
      },
      stop: l,
      targetIdx: null
    })
  }
  function m (n) {
    let i,
      e,
      a,
      o,
      u,
      s,
      c,
      f,
      h,
      m,
      g,
      b,
      x,
      y,
      k = 1 / 0,
      w = [],
      M = null,
      T = 0
    function C (n) {
      _(T + n)
    }
    function E (n) {
      const t = z(T + n).abs
      return D(t) ? t : null
    }
    function z (n) {
      let i = Math.floor(Math.abs(v(n / e))),
        r = v(((n % e) + e) % e)
      r === e && (r = 0)
      let a = l(n),
        o = c.indexOf(
          t([], c, !0).reduce((n, t) => {
            return Math.abs(t - r) < Math.abs(n - r) ? t : n
          })
        ),
        u = o
      return (
        a < 0 && i++,
        o === s && ((u = 0), (i += a > 0 ? 1 : -1)),
        { abs: u + i * s * a, origin: o, rel: u }
      )
    }
    function I (n, t, i) {
      let e
      if (t || !S()) return A(n, i)
      if (!D(n)) return null
      let r = z(i != null ? i : T),
        a = r.abs,
        o = n - r.rel,
        u = a + o
      e = A(u)
      const c = A(u - s * l(o))
      return (
        ((c !== null && Math.abs(c) < Math.abs(e)) || e === null) && (e = c),
        v(e)
      )
    }
    function A (n, t) {
      if ((t == null && (t = v(T)), !D(n) || n === null)) return null
      n = Math.round(n)
      let i = z(t),
        r = i.abs,
        a = i.rel,
        o = i.origin,
        u = O(n),
        d = ((t % e) + e) % e,
        l = c[o],
        f = Math.floor((n - (r - a)) / s) * e
      return v(l - d - l + c[u] + f + (o === s ? e : 0))
    }
    function D (n) {
      return L(n) === n
    }
    function L (n) {
      return d(n, h, m)
    }
    function S () {
      return o.loop
    }
    function O (n) {
      return ((n % s) + s) % s
    }
    function _ (t) {
      let i
      ;(i = t - T),
      w.push({ distance: i, timestamp: r() }),
      w.length > 6 && (w = w.slice(-6)),
      (T = v(t))
      const e = H().abs
      if (e !== M) {
        const a = M !== null
        ;(M = e), a && n.emit('slideChanged')
      }
    }
    function H (t) {
      const r = t
        ? null
        : (function () {
          if (s) {
            let n = S(),
              t = n ? ((T % e) + e) % e : T,
              i = (n ? T % e : T) - u[0][2],
              r = 0 - (i < 0 && n ? e - Math.abs(i) : i),
              c = 0,
              d = z(T),
              f = d.abs,
              p = d.rel,
              v = u[p][2],
              k = u.map((t, i) => {
                let a = r + c
                  ;(a < 0 - t[0] || a > 1) &&
                    (a += (Math.abs(a) > e - 1 && n ? e : 0) * l(-a))
                let u = i - p,
                  d = l(u),
                  h = u + f
                n &&
                    (d === -1 && a > v && (h += s),
                      d === 1 && a < v && (h -= s),
                      g !== null && h < g && (a += e),
                      b !== null && h > b && (a -= e))
                let m = a + t[0] + t[1],
                  x = Math.max(
                    a >= 0 && m <= 1
                      ? 1
                      : m < 0 || a > 1
                        ? 0
                        : a < 0
                          ? Math.min(1, (t[0] + a) / t[0])
                          : (1 - a) / t[0],
                    0
                  )
                return (
                  (c += t[0] + t[1]),
                  {
                    abs: h,
                    distance: o.rtl ? -1 * a + 1 - t[0] : a,
                    portion: x,
                    size: t[0]
                  }
                )
              })
            return (
              (f = L(f)),
              (p = O(f)),
              {
                abs: L(f),
                length: a,
                max: y,
                maxIdx: m,
                min: x,
                minIdx: h,
                position: T,
                progress: n ? t / e : T / a,
                rel: p,
                slides: k,
                slidesLength: e
              }
            )
          }
        })()
      return (i.details = r), n.emit('detailsChanged'), r
    }
    return (i = {
      absToRel: O,
      add: C,
      details: null,
      distToIdx: E,
      idxToDist: I,
      init (t) {
        if (
          ((function () {
            if (
              ((o = n.options),
                (u = (o.trackConfig || []).map((n) => {
                  return [p(n, 'size', 1), p(n, 'spacing', 0), p(n, 'origin', 0)]
                })),
                (s = u.length))
            ) {
              e = v(
                u.reduce((n, t) => {
                  return n + t[0] + t[1]
                }, 0)
              )
              let t,
                i = s - 1
              ;(a = v(e + u[0][2] - u[i][0] - u[i][2] - u[i][1])),
              (c = u.reduce((n, i) => {
                if (!n) return [0]
                let e = u[n.length - 1],
                  r = n[n.length - 1] + (e[0] + e[2]) + e[1]
                return (
                  (r -= i[2]),
                  n[n.length - 1] > r && (r = n[n.length - 1]),
                  (r = v(r)),
                  n.push(r),
                  (!t || t < r) && (f = n.length - 1),
                  (t = r),
                  n
                )
              }, null)),
              a === 0 && (f = 0),
              c.push(v(e))
            }
          })(),
            !s)
        ) { return H(!0) }
        let i
        !(function () {
          let t = n.options.range,
            i = n.options.loop
          ;(g = h = i ? p(i, 'min', -1 / 0) : 0),
          (b = m = i ? p(i, 'max', k) : f)
          let e = p(t, 'min', null),
            r = p(t, 'max', null)
          e && (h = e),
          r && (m = r),
          (x = h === -1 / 0 ? h : n.track.idxToDist(h || 0, !0, 0)),
          (y = m === k ? m : I(m, !0, 0)),
          r === null && (b = m),
          p(t, 'align', !1) &&
              m !== k &&
              u[O(m)][2] === 0 &&
              ((y -= 1 - u[O(m)][0]), (m = E(y - T))),
          (x = v(x)),
          (y = v(y))
        })(),
        (i = t),
        Number(i) === i ? C(A(L(t))) : H()
      },
      to: _,
      velocity () {
        let n = r(),
          t = w.reduce(
            (t, i) => {
              let e = i.distance,
                r = i.timestamp
              return (
                n - r > 200 ||
                  (l(e) !== l(t.distance) &&
                    t.distance &&
                    (t = { distance: 0, lastTimestamp: 0, time: 0 }),
                    t.time && (t.distance += e),
                    t.lastTimestamp && (t.time += r - t.lastTimestamp),
                    (t.lastTimestamp = r)),
                t
              )
            },
            { distance: 0, lastTimestamp: 0, time: 0 }
          )
        return t.distance / t.time || 0
      }
    })
  }
  function g (n) {
    let t, i, e, r, a, o, u, s
    function c (n) {
      return 2 * n
    }
    function f (n) {
      return d(n, u, s)
    }
    function p (n) {
      return 1 - Math.pow(1 - n, 3)
    }
    function v () {
      return e ? n.track.velocity() : 0
    }
    function h () {
      b()
      let t = n.options.mode === 'free-snap',
        i = n.track,
        e = v()
      r = l(e)
      let u = n.track.details,
        s = []
      if (e || !t) {
        let d = m(e),
          h = d.dist,
          g = d.dur
        if (((g = c(g)), (h *= r), t)) {
          const x = i.idxToDist(i.distToIdx(h), !0)
          x && (h = x)
        }
        s.push({ distance: h, duration: g, easing: p })
        let y = u.position,
          k = y + h
        if (k < a || k > o) {
          let w = k < a ? a - y : o - y,
            M = 0,
            T = e
          if (l(w) === r) {
            let C = Math.min(Math.abs(w) / Math.abs(h), 1),
              E =
                (function (n) {
                  return 1 - Math.pow(1 - n, 1 / 3)
                })(C) * g
            ;(s[0].earlyExit = E), (T = e * (1 - C))
          } else (s[0].earlyExit = 0), (M += w)
          let z = m(T, 100),
            I = z.dist * r
          n.options.rubberband &&
            (s.push({ distance: I, duration: c(z.dur), easing: p }),
              s.push({ distance: -I + M, duration: 500, easing: p }))
        }
        n.animator.start(s)
      } else {
        n.moveToIdx(f(u.abs), !0, {
          duration: 500,
          easing (n) {
            return 1 + --n * n * n * n * n
          }
        })
      }
    }
    function m (n, t) {
      void 0 === t && (t = 1e3)
      const i = 147e-9 + (n = Math.abs(n)) / t
      return { dist: Math.pow(n, 2) / i, dur: n / i }
    }
    function g () {
      const t = n.track.details
      t && ((a = t.min), (o = t.max), (u = t.minIdx), (s = t.maxIdx))
    }
    function b () {
      n.animator.stop()
    }
    n.on('updated', g),
    n.on('optionsChanged', g),
    n.on('created', g),
    n.on('dragStarted', () => {
      ;(e = !1), b(), (t = i = n.track.details.abs)
    }),
    n.on('dragChecked', () => {
      e = !0
    }),
    n.on('dragEnded', () => {
      const e = n.options.mode
      e === 'snap' &&
          (function () {
            let e = n.track,
              r = n.track.details,
              u = r.position,
              s = l(v())
            ;(u > o || u < a) && (s = 0)
            let c = t + s
            r.slides[e.absToRel(c)].portion === 0 && (c -= s),
            t !== i && (c = i),
            l(e.idxToDist(c, !0)) !== s && (c += s),
            (c = f(c))
            const d = e.idxToDist(c, !0)
            n.animator.start([
              {
                distance: d,
                duration: 500,
                easing (n) {
                  return 1 + --n * n * n * n * n
                }
              }
            ])
          })(),
      (e !== 'free' && e !== 'free-snap') || h()
    }),
    n.on('dragged', () => {
      i = n.track.details.abs
    })
  }
  function b (n) {
    let t,
      i,
      e,
      r,
      a,
      f,
      p,
      v,
      h,
      m,
      g,
      b,
      x,
      y,
      k,
      w,
      M,
      T,
      C = c()
    function E (t) {
      if (f && v === t.id) {
        const o = D(t)
        if (h) {
          if (!A(t)) return I(t)
          ;(m = o), (h = !1), n.emit('dragChecked')
        }
        if (w) return (m = o)
        u(t)
        const c = (function (t) {
          if (M === -1 / 0 && T === 1 / 0) return t
          let e = n.track.details,
            o = e.length,
            u = e.position,
            s = d(t, M - u, T - u)
          if (o === 0) return 0
          if (!n.options.rubberband) return s
          if (u <= T && u >= M) return t
          if ((u < M && i > 0) || (u > T && i < 0)) return t
          let c = (u < M ? u - M : u - T) / o,
            l = r * o,
            f = Math.abs(c * l),
            p = Math.max(0, 1 - (f / a) * 2)
          return p * p * t
        })((p(m - o) / r) * e)
        i = l(c)
        const x = n.track.details.position
        ;((x > M && x < T) || (x === M && i > 0) || (x === T && i < 0)) && s(t),
        (g += c),
        !b && Math.abs(g * r) > 5 && (b = !0),
        n.track.add(c),
        (m = o),
        n.emit('dragged')
      }
    }
    function z (t) {
      !f &&
        n.track.details &&
        n.track.details.length &&
        ((g = 0),
          (f = !0),
          (b = !1),
          (h = !0),
          (v = t.id),
          A(t),
          (m = D(t)),
          n.emit('dragStarted'))
    }
    function I (t) {
      f && v === t.idChanged && ((f = !1), n.emit('dragEnded'))
    }
    function A (n) {
      let t = L(),
        i = t ? n.y : n.x,
        e = t ? n.x : n.y,
        r = void 0 !== x && void 0 !== y && Math.abs(y - e) <= Math.abs(x - i)
      return (x = i), (y = e), r
    }
    function D (n) {
      return L() ? n.y : n.x
    }
    function L () {
      return n.options.vertical
    }
    function S () {
      ;(r = n.size), (a = L() ? window.innerHeight : window.innerWidth)
      const t = n.track.details
      t && ((M = t.min), (T = t.max))
    }
    function O (n) {
      b && (s(n), u(n))
    }
    function _ () {
      if ((C.purge(), n.options.drag && !n.options.disabled)) {
        let i
        ;(i = n.options.dragSpeed || 1),
        (p =
            typeof i === 'function'
              ? i
              : function (n) {
                return n * i
              }),
        (e = n.options.rtl ? -1 : 1),
        S(),
        (t = n.container),
        (function () {
          const n = 'data-keen-slider-clickable'
          o('['.concat(n, ']:not([').concat(n, '=false])'), t).map((
            n
          ) => {
            C.add(n, 'dragstart', s),
            C.add(n, 'mousedown', s),
            C.add(n, 'touchstart', s)
          })
        })(),
        C.add(t, 'dragstart', (n) => {
          u(n)
        }),
        C.add(t, 'click', O, { capture: !0 }),
        C.input(t, 'ksDragStart', z),
        C.input(t, 'ksDrag', E),
        C.input(t, 'ksDragEnd', I),
        C.input(t, 'mousedown', z),
        C.input(t, 'mousemove', E),
        C.input(t, 'mouseleave', I),
        C.input(t, 'mouseup', I),
        C.input(t, 'touchstart', z, { passive: !0 }),
        C.input(t, 'touchmove', E, { passive: !1 }),
        C.input(t, 'touchend', I),
        C.input(t, 'touchcancel', I),
        C.add(window, 'wheel', (n) => {
          f && u(n)
        })
        const r = 'data-keen-slider-scrollable'
        o('['.concat(r, ']:not([').concat(r, '=false])'), n.container).map(
          (n) => {
            return (function (n) {
              let t
              C.input(
                n,
                'touchstart',
                (n) => {
                  ;(t = D(n)), (w = !0), (k = !0)
                },
                { passive: !0 }
              ),
              C.input(n, 'touchmove', (i) => {
                let e = L(),
                  r = e
                    ? n.scrollHeight - n.clientHeight
                    : n.scrollWidth - n.clientWidth,
                  a = t - D(i),
                  o = e ? n.scrollTop : n.scrollLeft,
                  s =
                      (e && n.style.overflowY === 'scroll') ||
                      (!e && n.style.overflowX === 'scroll')
                if (
                  ((t = D(i)),
                    ((a < 0 && o > 0) || (a > 0 && o < r)) && k && s)
                ) {
                  return (w = !0)
                }(k = !1), u(i), (w = !1)
              }),
              C.input(n, 'touchend', () => {
                w = !1
              })
            })(n)
          }
        )
      }
    }
    n.on('updated', S),
    n.on('optionsChanged', _),
    n.on('created', _),
    n.on('destroyed', C.purge)
  }
  function x (n) {
    let t,
      i,
      e = null
    function r (t, i, e) {
      n.animator.active
        ? o(t, i, e)
        : requestAnimationFrame(() => {
          return o(t, i, e)
        })
    }
    function a () {
      r(!1, !1, i)
    }
    function o (i, r, a) {
      let o = 0,
        u = n.size,
        d = n.track.details
      if (d && t) {
        const l = d.slides
        t.forEach((n, t) => {
          if (i) !e && r && s(n, null, a), c(n, null, a)
          else {
            if (!l[t]) return
            const d = l[t].size * u
            !e && r && s(n, d, a), c(n, l[t].distance * u - o, a), (o += d)
          }
        })
      }
    }
    function u (t) {
      return n.options.renderMode === 'performance' ? Math.round(t) : t
    }
    function s (n, t, i) {
      const e = i ? 'height' : 'width'
      t !== null && (t = `${u(t)}px`),
      (n.style[`min-${e}`] = t),
      (n.style[`max-${e}`] = t)
    }
    function c (n, t, i) {
      if (t !== null) {
        t = u(t)
        const e = i ? t : 0
        t = 'translate3d('.concat(i ? 0 : t, 'px, ').concat(e, 'px, 0)')
      }
      ;(n.style.transform = t), (n.style['-webkit-transform'] = t)
    }
    function d () {
      t && (o(!0, !0, i), (t = null)), n.on('detailsChanged', a, !0)
    }
    function l () {
      r(!1, !0, i)
    }
    function f () {
      d(),
      (i = n.options.vertical),
      n.options.disabled ||
          n.options.renderMode === 'custom' ||
          ((e = p(n.options.slides, 'perView', null) === 'auto'),
            n.on('detailsChanged', a),
            (t = n.slides).length && l())
    }
    n.on('created', f),
    n.on('optionsChanged', f),
    n.on('beforeOptionsChanged', () => {
      d()
    }),
    n.on('updated', l),
    n.on('destroyed', d)
  }
  function y (t, i) {
    return function (e) {
      let r,
        u,
        s,
        d,
        l,
        v,
        h = c()
      function m (n) {
        let t
        a(
          e.container,
          'reverse',
          ((t = e.container),
            window.getComputedStyle(t, null).getPropertyValue('direction')) !==
            'rtl' || n
            ? null
            : ''
        ),
        a(e.container, 'v', e.options.vertical && !n ? '' : null),
        a(e.container, 'disabled', e.options.disabled && !n ? '' : null)
      }
      function g () {
        b() && M()
      }
      function b () {
        let t = null
        if (
          (d.forEach((n) => {
            n.matches && (t = n.__media)
          }),
            t === r)
        ) { return !1 }
        r || e.emit('beforeOptionsChanged'), (r = t)
        const i = t ? s.breakpoints[t] : s
        return (e.options = n(n({}, s), i)), m(), I(), A(), C(), !0
      }
      function x (n) {
        const t = f(n)
        return (e.options.vertical ? t.height : t.width) / e.size || 1
      }
      function y () {
        return e.options.trackConfig.length
      }
      function k (t) {
        for (const a in ((r = !1),
          (s = n(n({}, i), t)),
          h.purge(),
          (u = e.size),
          (d = []),
          s.breakpoints || [])) {
          const o = window.matchMedia(a)
          ;(o.__media = a), d.push(o), h.add(o, 'change', g)
        }
        h.add(window, 'orientationchange', z), h.add(window, 'resize', E), b()
      }
      function w (n) {
        e.animator.stop()
        const t = e.track.details
        e.track.init(n != null ? n : t ? t.abs : 0)
      }
      function M (n) {
        w(n), e.emit('optionsChanged')
      }
      function T (n, t) {
        if (n) return k(n), void M(t)
        I(), A()
        const i = y()
        C(), y() !== i ? M(t) : w(t), e.emit('updated')
      }
      function C () {
        const n = e.options.slides
        if (typeof n === 'function') { return (e.options.trackConfig = n(e.size, e.slides)) }
        for (
          var t = e.slides,
            i = t.length,
            r = typeof n === 'number' ? n : p(n, 'number', i, !0),
            a = [],
            o = p(n, 'perView', 1, !0),
            u = p(n, 'spacing', 0, !0) / e.size || 0,
            s = o === 'auto' ? u : u / o,
            c = p(n, 'origin', 'auto'),
            d = 0,
            l = 0;
          l < r;
          l++
        ) {
          let f = o === 'auto' ? x(t[l]) : 1 / o - u + s,
            v = c === 'center' ? 0.5 - f / 2 : c === 'auto' ? 0 : c
          a.push({ origin: v, size: f, spacing: u }), (d += f)
        }
        if (((d += u * (r - 1)), c === 'auto' && !e.options.loop && o !== 1)) {
          let h = 0
          a.map((n) => {
            const t = d - h
            return (
              (h += n.size + u),
              t >= 1 || (n.origin = 1 - t - (d > 1 ? 0 : 1 - d)),
              n
            )
          })
        }
        e.options.trackConfig = a
      }
      function E () {
        I()
        const n = e.size
        e.options.disabled || n === u || ((u = n), T())
      }
      function z () {
        E(), setTimeout(E, 500), setTimeout(E, 2e3)
      }
      function I () {
        const n = f(e.container)
        e.size = (e.options.vertical ? n.height : n.width) || 1
      }
      function A () {
        e.slides = o(e.options.selector, e.container)
      }
      ;(e.container = (v = o(t, l || document)).length ? v[0] : null),
      (e.destroy = function () {
        h.purge(), e.emit('destroyed'), m(!0)
      }),
      (e.prev = function () {
        e.moveToIdx(e.track.details.abs - 1, !0)
      }),
      (e.next = function () {
        e.moveToIdx(e.track.details.abs + 1, !0)
      }),
      (e.update = T),
      k(e.options)
    }
  }
  return function (n, i, e) {
    try {
      return (function (n, t) {
        let i,
          e = {}
        return (
          (i = {
            emit (n) {
              e[n] &&
                e[n].forEach((n) => {
                  n(i)
                })
              const t = i.options && i.options[n]
              t && t(i)
            },
            moveToIdx (n, t, e) {
              const r = i.track.idxToDist(n, t)
              if (r) {
                const a = i.options.defaultAnimation
                i.animator.start([
                  {
                    distance: r,
                    duration: p(e || a, 'duration', 500),
                    easing: p(e || a, 'easing', (n) => {
                      return 1 + --n * n * n * n * n
                    })
                  }
                ])
              }
            },
            on (n, t, i) {
              void 0 === i && (i = !1), e[n] || (e[n] = [])
              const r = e[n].indexOf(t)
              r > -1 ? i && delete e[n][r] : i || e[n].push(t)
            },
            options: n
          }),
          (function () {
            if (((i.track = m(i)), (i.animator = h(i)), t)) { for (let n = 0, e = t; n < e.length; n++) (0, e[n])(i) }
            i.track.init(i.options.initial || 0), i.emit('created')
          })(),
          i
        )
      })(
        i,
        t(
          [
            y(n, {
              drag: !0,
              mode: 'snap',
              renderMode: 'precision',
              rubberband: !0,
              selector: '.keen-slider__slide'
            }),
            x,
            b,
            g
          ],
          e || [],
          !0
        )
      )
    } catch (n) {
      console.error(n)
    }
  }
})
